<template>
    <div ref="chart" style="width: 100%;height: 100%;position: relative"></div>
</template>

<script>
import Charts from '@jiaminghi/charts'

export default {
	name: "chart-item",
	data() {
		return {myChart: null}
	},
	methods: {
		setConfig(config) {
			if (this.myChart) {
				this.myChart.setOption(config)
			}else {
				const el = this.$refs.chart
				this.myChart = new Charts(el)
				this.myChart.setOption(config)
            }
		}

	}
}
</script>

<style scoped>

</style>
